import DefaultTemplate from "./DefaultTemplate";
export default DefaultTemplate;
